module.exports = __webpack_public_path__ + "static/media/vipul.a9046cc1.jpg";